import React, { useState } from 'react';

const RoutineStart = ({ routine, onBack, onStart }) => {
  const [mode, setMode] = useState(routine.watchOnly ? 'watch' : (routine.defaultMode || 'tap'));
  return (
    <main className="min-h-screen bg-black text-white flex items-center justify-center p-5 overflow-y-auto">
      <section className="w-full max-w-md rounded-3xl border border-white/10 bg-gradient-to-b from-slate-900 to-[#10172a] p-6 shadow-2xl">
        <button type="button" onClick={onBack} className="text-sm text-indigo-200/70">← All routines</button>
        <p className="mt-7 text-[0.625rem] font-bold uppercase tracking-[0.2em] text-indigo-300">{routine.durationMinutes} minutes</p>
        <h1 className="mt-2 text-3xl font-extrabold">{routine.title}</h1>
        <p className="mt-3 leading-relaxed text-white/55">{routine.description}</p>
        <div className="mt-4 flex flex-wrap gap-2 text-[0.6875rem] text-indigo-100/65">
          <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5">{routine.paceLabel}</span>
          <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5">{routine.visualLabel}</span>
        </div>
        <p className="mt-5 rounded-2xl bg-white/5 p-4 text-sm leading-relaxed text-white/70">{routine.openingPrompt}</p>

        {routine.watchOnly ? (
          <div className="mt-6 rounded-2xl border border-violet-300/20 bg-violet-500/10 p-4">
            <p className="text-xs font-bold uppercase tracking-widest text-violet-200">Watch the rhythm</p>
            <p className="mt-2 text-sm leading-relaxed text-white/60">No tapping is needed. The orbs fade gently from side to side on their own.</p>
          </div>
        ) : (
          <fieldset className="mt-6">
            <legend className="text-xs font-bold uppercase tracking-widest text-white/45">Choose how to follow</legend>
            <div className="mt-3 grid grid-cols-2 gap-3">
              <button type="button" onClick={() => setMode('tap')} aria-pressed={mode === 'tap'} className={`rounded-2xl border p-4 text-left ${mode === 'tap' ? 'border-blue-300/40 bg-blue-500/15' : 'border-white/10 bg-white/5'}`}>
                <span className="block font-bold">Tap along</span><span className="mt-1 block text-xs text-white/45">Tap each side yourself</span>
              </button>
              <button type="button" onClick={() => setMode('watch')} aria-pressed={mode === 'watch'} className={`rounded-2xl border p-4 text-left ${mode === 'watch' ? 'border-violet-300/40 bg-violet-500/15' : 'border-white/10 bg-white/5'}`}>
                <span className="block font-bold">Watch the rhythm</span><span className="mt-1 block text-xs text-white/45">The orbs move automatically</span>
              </button>
            </div>
          </fieldset>
        )}

        <button type="button" onClick={() => onStart(mode)} className="mt-7 w-full rounded-2xl bg-gradient-to-r from-blue-600 to-purple-600 p-4 font-bold active:scale-95 transition-transform">Begin routine</button>
      </section>
    </main>
  );
};

export default RoutineStart;
